module.exports = __webpack_public_path__ + "img/1.919138e8.png";